module.exports = __webpack_public_path__ + "img/portfolio_4.73bec479.jpg";